module.exports = __webpack_public_path__ + "img/hc_pro_three_7.6ec98760.jpg";